import React from "react"
import {navigate} from "gatsby";
import _ from "lodash";
import CartSummary from "../CartSummary";
import {ButtonThin} from "../Button";
import CartItemList from "../CartItemList";

export default ({cartInfo, loading, onClickBackButton}) => {
  const backButtonHandler = onClickBackButton || function() {navigate("/product/")}

  if (!_.isEmpty(cartInfo)) {
    return (
      <>
        <CartSummary cart={cartInfo}/>
        <div style={{
          margin: "10px auto 30px",
          textAlign: "center",
        }}>
          <ButtonThin attr={{onClick: backButtonHandler}}>買い物を続ける</ButtonThin>
        </div>
        <CartItemList cart={cartInfo}/>
      </>
    )
  } else if (loading === false) {
    return (
      <>
        <p style={{
          padding: "40px 0 10px",
          textAlign: "center",
        }}>カートに商品は入っていません。</p>
        <div style={{
          margin: "10px auto 30px",
          textAlign: "center",
        }}>
          <ButtonThin attr={{onClick: backButtonHandler}}>買い物を続ける</ButtonThin>
        </div>
      </>
    )
  } else {
    return (<></>)
  }
}